import { render, staticRenderFns } from "./CustomFieldBuilder.vue?vue&type=template&id=442e1ecc&scoped=true&"
import script from "./CustomFieldBuilder.vue?vue&type=script&lang=js&"
export * from "./CustomFieldBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e1ecc",
  null
  
)

export default component.exports